import React from 'react';
import { Box } from '@mui/material';
import { HeaderMenu, UserMenu } from '../types';
import HeaderMainMenu from './HeaderMainMenu';
import HeaderUserMenu from './HeaderUserMenu';
import HeaderNotificationsMenu from './HeaderNotificationsMenu';

const MENU: HeaderMenu = [
	{
		path: '/',
		label: 'Home',
	},
	{
		path: '/forum',
		label: 'Forum',
	},
	{
		path: '/providers',
		label: 'Solution Providers',
	},
	{
		path: '/networking',
		label: 'Networking',
	},
	{
		path: '/community',
		label: 'Community',
	},
	{
		path: '/events',
		label: 'Events',
	},
	{
		path: '/job-postings',
		label: 'Job Postings',
	},
];

const USER_MENU: UserMenu = [
	{
		path: '/company',
		label: 'Law firm',
	},
	{
		path: '/profile',
		label: 'Profile',
	},
	{
		path: '/messenger',
		label: 'Messenger',
	},
	{
		path: '/favorites',
		label: 'Favorites',
	},
	{
		path: '/invitations',
		label: 'Invite',
	},
	{
		path: '/logout',
		label: 'Sign Out',
	},
];

export default function MemberMenu() {
	return (
		<>
			<Box>
				<HeaderMainMenu items={MENU} />
			</Box>
			<Box mx={1}>
				<HeaderNotificationsMenu />
			</Box>
			<Box>
				<HeaderUserMenu items={USER_MENU} />
			</Box>
		</>
	);
}
